














import { Component, Vue } from 'vue-property-decorator';
import StoreLayout from '~/components/Store/StoreLayout.vue';
import PromoBannerCarousel from '~/components/Promotions/PromoBannerCarousel.vue';
import PromoBanner from '~/components/Promotions/PromoBanner.vue';
import { IBanner } from '~/types/banner';
import { intlHead } from '~/utils/i18n_head';
import { Getter } from 'vuex-class';

@Component({
  head: intlHead({
    ogTitleKey: 'store.htmlMeta.ogTitle',
    ogDescriptionKey: 'store.htmlMeta.htmlDescription',
    htmlDescriptionKey: 'store.htmlMeta.htmlDescription',
  }),
  components: {
    StoreLayout,
    PromoBannerCarousel,
    PromoBanner,
  },
})
export default class StorePage extends Vue {
  @Getter('storeBanners', { namespace: 'cmsContent' })
  readonly storeBanners!: IBanner[];
  @Getter('storeBanner', { namespace: 'cmsContent' })
  readonly storeBanner!: IBanner;
}
